module.exports = __webpack_public_path__ + "img/base_patrimoine_archeologie.b6bbb397.svg";